export default {
  COMMENT_SELECTION_CHANGE: 'comment_moderation/COMMENT_SELECTION_CHANGE',
  COMMENTS_SELECT_VISIBLE: 'comment_moderation/COMMENTS_SELECT_VISIBLE',
  COMMENTS_SELECT_HIDDEN: 'comment_moderation/COMMENTS_SELECT_HIDDEN',
  COMMENTS_SELECT_ALL: 'comment_moderation/COMMENTS_SELECT_ALL',
  COMMENTS_DESELECT_ALL: 'comment_moderation/COMMENTS_DESELECT_ALL',
  BULK_SHOW_COMMENTS_START: 'comment_moderation/BULK_SHOW_COMMENTS_START',
  BULK_HIDE_COMMENTS_START: 'comment_moderation/BULK_HIDE_COMMENTS_START',
  BULK_SHOW_COMMENTS_SUCCESS: 'comment_moderation/BULK_SHOW_COMMENTS_SUCCESS',
  BULK_HIDE_COMMENTS_SUCCESS: 'comment_moderation/BULK_HIDE_COMMENTS_SUCCESS',
  BULK_SHOW_COMMENTS_ERROR: 'comment_moderation/BULK_SHOW_COMMENTS_ERROR',
  BULK_HIDE_COMMENTS_ERROR: 'comment_moderation/BULK_HIDE_COMMENTS_ERROR',
}
